export default (entity = {}) => {
    return {
        restId: entity.restId || undefined,
        amount: entity.amount || 0,
        recipient: entity.recipient || '',
        text: entity.text || '',
        month: entity.month || new Date().getMonth() + 1,
        year: entity.year || new Date().getFullYear(),
        currencyCode: entity.currencyCode || 'ILS',
        vat: entity.vat || '',
        email: entity.email || '',
    };
};
